/**
 * The ETERNALLY wordmark. Typographic only, no icon, no symbol, ever.
 *
 * ETER carries full weight and full text colour; NALLY continues in a
 * visibly lighter weight at reduced opacity. Same size, same baseline,
 * same tracking: the contrast is weight and presence, nothing else.
 * The compact variant stacks ETER above NALLY, right-aligned, because
 * NALLY must never appear without ETER above or before it.
 *
 * Weights and opacity come from CSS custom properties on :root so the
 * identity is centrally tuned rather than per instance.
 */
export class EternallyWordmark extends HTMLElement {
  static observedAttributes = ['variant'];

  connectedCallback(): void {
    this.render();
  }

  attributeChangedCallback(): void {
    this.render();
  }

  private render(): void {
    const compact = this.getAttribute('variant') === 'compact';
    const root = this.shadowRoot ?? this.attachShadow({ mode: 'open' });
    root.innerHTML = `
      <style>
        :host {
          display: inline-block;
          font-family: var(--font-wordmark, inherit);
          font-size: var(--wordmark-size, 0.9375rem);
          line-height: 1;
          letter-spacing: var(--wordmark-tracking, 0.32em);
          text-transform: uppercase;
          white-space: nowrap;
          user-select: none;
          -webkit-user-select: none;
        }
        .mark {
          display: ${compact ? 'grid' : 'inline'};
          ${compact ? 'justify-items: end;' : ''}
        }
        .eter {
          font-weight: var(--wordmark-weight-strong, 600);
          color: currentColor;
        }
        .nally {
          font-weight: var(--wordmark-weight-light, 260);
          opacity: var(--wordmark-nally-opacity, 0.45);
          color: currentColor;
        }
      </style>
      <span class="mark" role="img" aria-label="ETERNALLY">
        <span class="eter" aria-hidden="true">ETER</span><span class="nally" aria-hidden="true">NALLY</span>
      </span>
    `;
  }
}

customElements.define('eternally-wordmark', EternallyWordmark);
